import { createFileRoute } from '@tanstack/react-router';
import { CircleCheck } from 'lucide-react';

import { SurveyStatusContent } from '../../@components/StatusContent';

export const Route = createFileRoute(
  '/_layout/$lang/quality-survey/_layout/not-completed/submitted',
)({
  component: NotCompletedSubmitted,
});

function NotCompletedSubmitted() {
  return (
    <SurveyStatusContent
      icon={CircleCheck}
      iconBgClassName="bg-emerald-50"
      iconClassName="text-emerald-500"
      messageKey="survey.submitted.not_completed.message"
      titleKey="survey.submitted.title"
    />
  );
}
